import { subPaths } from '@bit/bit.utils.fs.sub-paths';
import { TreeNode } from '../tree-types';
type KeyTree = { [filePath: string]: KeyTree | undefined };

export function inflateToTree(files: string[]) {
	const treeSkeleton = buildSkeleton(files);
	const rootKeys = Object.keys(treeSkeleton);

	if (rootKeys.length !== 1) {
		return skeletonToFullTree('', treeSkeleton);
	}

	const singleRoot = rootKeys[0];
	const root = treeSkeleton[singleRoot];
	return skeletonToFullTree(singleRoot, root);
}

function buildSkeleton(files: string[]): KeyTree {
	const treeRoot: KeyTree = {};

	files.forEach(filePath => {
		const segments = subPaths(filePath);
		const fileName = segments.pop();

		let currentFolder = treeRoot;

		segments.forEach(dirname => {
			const nextFolder = currentFolder[dirname] || {};
			currentFolder[dirname] = nextFolder;
			currentFolder = nextFolder;
		});

		if (!fileName) return;
		//folders may repeat, do not override
		if (currentFolder[fileName]) return;

		const isFolder = filePath.endsWith('/');
		currentFolder[fileName] = isFolder ? {} : undefined;
	});

	return treeRoot;
}

function skeletonToFullTree(nodeId: string, tree?: KeyTree ): TreeNode<undefined> {
	//leaf:
	if (!tree) {
		return {
			id: nodeId,
			children: undefined,
			// payload: undefined,
		};
	}

	//innerNode:
	return {
		id: nodeId,
		children: Object.entries(tree)
			.sort(([key1], [key2]) => (key1 < key2 ? -1 : 1)) //alphabetically
			.sort(
				([key1, node1], [key2, node2]) =>
					(node1 !== undefined ? -1 : 0) + (node2 !== undefined ? 1 : 0)
			)
			.map(([fullpath, children]) => skeletonToFullTree(fullpath, children)),
		// payload: undefined,
	};
}
